import * as $runtime from "../runtime.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Restaumatic$dAddress from "../Restaumatic.Address/index.js";
const toStoredDeliveryAddress = x => (
  {
    street: Data$dMaybe.$Maybe("Just", x.street),
    streetNumber: Data$dMaybe.$Maybe("Just", x.streetNumber),
    city: Data$dMaybe.$Maybe("Just", x.city),
    postCode: Data$dMaybe.$Maybe("Just", x.postCode)
  }
);
const fromStoredDeliveryAddress = x => (
  {
    street: (() => {
      if (x.street.tag === "Nothing") { return ""; }
      if (x.street.tag === "Just") { return x.street._1; }
      $runtime.fail();
    })(),
    streetNumber: (() => {
      if (x.streetNumber.tag === "Nothing") { return ""; }
      if (x.streetNumber.tag === "Just") { return x.streetNumber._1; }
      $runtime.fail();
    })(),
    city: (() => {
      if (x.city.tag === "Nothing") { return ""; }
      if (x.city.tag === "Just") { return x.city._1; }
      $runtime.fail();
    })(),
    postCode: (() => {
      if (x.postCode.tag === "Nothing") { return ""; }
      if (x.postCode.tag === "Just") { return x.postCode._1; }
      $runtime.fail();
    })(),
    extra: Restaumatic$dAddress.emptyAddressExtra
  }
);
export {fromStoredDeliveryAddress, toStoredDeliveryAddress};
